import React, { useEffect, useRef, useState } from "react";
import { Modal_Frame } from "../components/Modal_Frame";
import model_mining_logo_2 from "../assets/LogoBasicoR.png";
import model_mining_logo_3 from "../assets/LogoCompleto.png";
import user_icon from "../assets/user_icon.png";
import mm_logo from "../assets/mm_logo.png";
import nvar_button from "../assets/barra_sidebar.png";
import chat_button from "../assets/chat_icon.svg";
import power_icon from "../assets/power_icon.png";
import { useLocation, useNavigate } from "react-router-dom";
import { checkAuthLogin } from "../services/checkAuthApi";
import { GpsGate_Frame } from "../components/GpsGate_Frame";
import Select from "react-select";
import { joinApplication } from "../services/initializeApplication";
import { IframeBlockerOverlay } from "../components/IframeBlockerOverlay";
import LoadEditor from "../features/LoadEditor/components/LoadEditor";
import EquipmentsHealthTable from "../features/EquipmentHealth/components/EquipmentsHealthTable";
import FieldNotificationWindow from "../features/FieldNotifications/components/FieldNotificationWindow";
import { logout } from "../services/logout";
import MainMapContainer from "./MainMapContainer";
import Swal from "sweetalert2";
import ModalGenerateTickets from "../components/ModalGenerateTickets";

export const Main_Application = () => {
  const [isContainerModalsOpen, setIsContainerModalsOpen] = useState(false);
  const [applicationList, setApplicationList] = useState([]);
  const [aplicationInfo, setAplicationInfo] = useState(null);
  const [selectedApp, setSelectedApp] = useState(null);
  const [isOpenSidebar, setIsOpenSidebar] = useState(false);
  const [isRefreshGpsFrame, setIsRefreshGpsFrame] = useState(true);
  const [sidebarTittle, setSidebarTittle] = useState("");
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState("");
  const [tokenAccessApi, setTokenAccessApi] = useState("");
  const [isAuthPage, setIsAuthPage] = useState(false);
  const [allMainMenu, setAllMainMenu] = useState([]);
  const [allSubMenu, setAllSubMenu] = useState([]);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const [sesionUserId, setSesionUserId] = useState("");

  const [geofenceShow, setGeofenceShow] = useState(false);
  const [equipmentModuleShow, setEquipmentModuleShow] = useState(false);

  const [openDropUser, setOpenDropUser] = useState(false);
  const UsermenuRef = useRef(null);

  const [applicationIsLicensed, setApplicationIsLicensed] = useState(false);
  const [licenseExpired, setLicenseExpired] = useState(null);

  const [showModalTicket, setShowModalTicket] = useState(false);

  const componentsSystem = {
    LoadEditor,
    EquipmentsHealthTable,
    FieldNotificationWindow,
  };

  const navigate = useNavigate();
  const location = useLocation();

  //console.log(location.state);

  useEffect(() => {
    (async () => {
      if (location.state && location.state.data) {
        const userInfo = location.state.data;
        //console.log("Información del usuario recibida:", userInfo);
        //console.log("Información de menu:", userInfo.appplication_menu);
        //console.log("Información de submenu:", userInfo.application_sub_menu);
        const token_access_api = localStorage.getItem("token_jwt");
        setTokenAccessApi(token_access_api);
        const result_check_auth = await checkAuthLogin(token_access_api);
        //console.log(result_check_auth);
        if (result_check_auth.page_is_auth == false) {
          localStorage.removeItem("token_jwt");
          navigate("/");
        } else {
          //console.log(userInfo)
          setIsAuthPage(result_check_auth.page_is_auth);
          setAllSubMenu(userInfo.application_sub_menu);
          setAllMainMenu(userInfo.application_menu);
          setSidebarTittle(userInfo.application_info.application_name);
          setAplicationInfo(userInfo.application_info);
          setUserName(userInfo.user_name);
          setUserId(userInfo.user_id);
          setApplicationList(userInfo.application_list);
          setSelectedApp(userInfo.application_selected);
          setSesionUserId(userInfo.login_id);
          //console.log('User info es:', userId)

          if (userInfo.application_info.app_has_license) {
            //console.log("Tiene informacion de licencia");
            //console.log("app info ", userInfo.application_info)
            //console.log(userInfo.application_info.app_license_end_date);
            //setApplicationIsLicensed(userInfo.application_info.app_has_license);
            setApplicationIsLicensed(true);

            const apiDate = new Date(
              userInfo.application_info.app_license_end_date
            );
            const nowUtc = new Date();

            const gmtOffset = userInfo.application_info.application_gmt; // -5
            const offsetMs = gmtOffset * 60 * 60 * 1000;

            // Ajustamos ambas fechas al GMT de la aplicación
            const apiDateGmt = new Date(apiDate.getTime() + offsetMs);
            const nowGmt = new Date(nowUtc.getTime() + offsetMs);

            // Normalizamos a medianoche
            const apiDateDay = Date.UTC(
              apiDateGmt.getUTCFullYear(),
              apiDateGmt.getUTCMonth(),
              apiDateGmt.getUTCDate()
            );
            const nowDay = Date.UTC(
              nowGmt.getUTCFullYear(),
              nowGmt.getUTCMonth(),
              nowGmt.getUTCDate()
            );

            const diffDays = Math.floor(
              (apiDateDay - nowDay) / (1000 * 60 * 60 * 24)
            );

            //console.log("Diferencia en días (aplicando GMT):", diffDays);

            //console.log("8888888888888888888888");
            //console.log(userInfo.application_info);
            //console.log(userInfo.application_info.app_license_end_date);
            //console.log(apiDateGmt);
            //console.log(nowGmt);
            //console.log("Diferencia en días:", diffDays);
            //console.log("8888888888888888888888");
            setLicenseExpired(diffDays);
          }
        }
      } else {
        localStorage.removeItem("token_jwt");
        navigate("/");
        var aux=0
      }
    })();
  }, [location, selectedApp, navigate]);

  useEffect(() => {
    let timer;
    if (isTransitioning) {
      timer = setTimeout(() => {
        setIsTransitioning(false);
      }, 300); // Coincide con la duración de la transición de tu sidebar
    }
    return () => clearTimeout(timer);
  }, [isTransitioning]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (UsermenuRef.current && !UsermenuRef.current.contains(event.target)) {
        setOpenDropUser(false); // Cierra el menú si el click fue afuera
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    (async () => {
      let timerInterval;
      if (licenseExpired <= 0 && licenseExpired != null) {
        await Swal.fire({
          title: "The license has expired",
          icon: "error",
          text: "The license has expired, to reactivate the system contact the service administrator",
          timer: 10000,
          showConfirmButton: false,
          showCancelButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          willClose: () => {
            clearInterval(timerInterval);
          },
        }).then((result) => {
          if (result.dismiss === Swal.DismissReason.timer) {
            //console.log("Se va a cerrar sesion");
            const result = logout(sesionUserId);
          }
        });
      }
    })();
  }, [licenseExpired]);
  

  const logout_action = async () => {
    //console.log('Se va a cerrar sesion ', sesionUserId);
    const result = await logout(sesionUserId);
  };
  const toggleSidebar = () => {
    setIsTransitioning(true);
    setIsOpenSidebar(!isOpenSidebar);
  };
  const toggleSubmenu = (id_menu) => {
    //console.log(id_menu);
    setAllMainMenu((prevMenus) =>
      prevMenus.map(
        (menu) =>
          menu.id_menu === id_menu
            ? { ...menu, is_show: !menu.is_show } // Cambia el valor de is_show
            : menu // Deja el resto de los menús sin cambios
      )
    );
  };
  const openModulesMenu = (id_sub_menu) => {
    //console.log(id_sub_menu);
    setAllSubMenu((prevSubMenu) =>
      prevSubMenu.map((subMenu) =>
        subMenu.id_sub_menu == id_sub_menu
          ? { ...subMenu, is_show: !subMenu.is_show }
          : subMenu
      )
    );
    setIsContainerModalsOpen(true);
    //console.log(allSubMenu);
  };
  //Tengo que validar que todos esten cerrados.
  const closeModulesMenu = (id_sub_menu) => {
    //console.log("Se cierra modal");
    //console.log(id_sub_menu);
    setAllSubMenu((prevSubMenu) =>
      prevSubMenu.map((subMenu) =>
        subMenu.id_sub_menu == id_sub_menu
          ? { ...subMenu, is_show: !subMenu.is_show }
          : subMenu
      )
    );
    //console.log(allSubMenu);
  };


  const minimizeModulesMenu = (id_sub_menu) => {
    //console.log("Se minimiza modal");
    //console.log(id_sub_menu);
    setAllSubMenu((prevSubMenu) =>
      prevSubMenu.map((subMenu) =>
        subMenu.id_sub_menu == id_sub_menu
          ? { ...subMenu, is_minimize: !subMenu.is_minimize }
          : subMenu
      )
    );

  };
  const focusModals = (id_sub_menu) => {
    //console.log("Se prioriza modal");
    //console.log(id_sub_menu);
      setAllSubMenu((prevSubMenu) =>
      prevSubMenu.map((subMenu) =>
        subMenu.id_sub_menu == id_sub_menu
          ? { ...subMenu, is_minimize: false }
          : subMenu
      )
    );
    setAllSubMenu((prevSubMenu) =>
      prevSubMenu.map((subMenu) =>
        subMenu.id_sub_menu == id_sub_menu
          ? { ...subMenu, zindex: 102 }
          : { ...subMenu, zindex: 101 }
      )
    );
    //console.log(allSubMenu);
  };

  const handleChangeApplication = async (selectedApp) => {
    setSelectedApp(selectedApp);
    //console.log(selectedApp);
    setIsRefreshGpsFrame(false);
    await joinApplication(userId, selectedApp, applicationList, navigate);
    setIsRefreshGpsFrame(true);
  };

  const handleShowGeofence = async () => {
    setEquipmentModuleShow(false);
    setGeofenceShow(!geofenceShow);
  }

  const handleShowEquipment = async () => {
    setGeofenceShow(false);
    setEquipmentModuleShow(!equipmentModuleShow);
  }

  return (
    <div>
      {isAuthPage === true &&
        applicationIsLicensed && ( // Contenedor principal que ahora usa flexbox horizontal para la sidebar y el contenido
          <div className="h-screen flex border-4">
            {/* NAV - 15 de altura */}
            <nav className="fixed top-0 left-0 right-0 h-14 bg-gray-100 flex items-center justify-between border-4  z-40 pointer-events-auto px-2">
              
              {/* DIV Izquierdo: Contiene el boton hamburguesa, select botones equipo y geocerca */}
              <div
                className={`flex space-x-4 items-center transition-all duration-100 ${
                  isOpenSidebar ? "ml-72" : ""
                }`}
              >
                <img
                  className="h-8 w-auto hover:bg-gray-200 rounded-md"
                  src={nvar_button}
                  alt="Model Mining"
                  onClick={toggleSidebar}
                />
                <div className="w-80">
                  <Select
                    className="ml-12 z-40"
                    value={selectedApp}
                    onChange={handleChangeApplication}
                    options={applicationList}
                  />
                </div>
                <div className="w-30">
                  <button
                    className="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white 
                py-2 px-4 border border-blue-500 hover:border-transparent rounded"
                    onClick={ handleShowEquipment}
                  >
                    Equipment
                  </button>
                </div>
                <div className="w-30">
                  <button
                    className="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white 
                py-2 px-4 border border-blue-500 hover:border-transparent rounded"
                    onClick={ handleShowGeofence}
                  >
                    Geofences
                  </button>
                </div>
              </div>

               {/* DIV Derecho: Contiene el select, trial y logo*/}
              <div className="flex items-center justify-center">
                {applicationIsLicensed && licenseExpired <= 30 && (
                  <div
                    className={`font-bold ${
                      licenseExpired <= 10 ? "text-red-400" : "text-black"
                    }`}
                  >
                    <p>Trial: {licenseExpired} Days</p>
                  </div>
                )}
                <div className="w-30">
                  <a href="https://modelmining.com/" target="_blank">
                    <img
                      className="h-11 w-auto hover:bg-gray-200 rounded-md cursor-pointer"
                      src={model_mining_logo_2}
                      alt="Model Mining"
                    />
                  </a>
                </div>
                <div ref={UsermenuRef} className="w-30 relative">
                  {/* Botón usuario */}
                  <button
                    onClick={() => setOpenDropUser(!openDropUser)}
                    className="inline-flex w-full justify-center z-40 gap-x-1.5 rounded-md bg-white/10 px-3 py-2 text-sm font-semibold text-white inset-ring-1 inset-ring-white/5 hover:bg-white/20"
                  >
                    <img
                      className="h-7 w-auto hover:bg-gray-200 rounded-md cursor-pointer"
                      src={user_icon}
                      alt="Model Mining"
                    />
                    <svg
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                      className="-mr-1 size-5 text-gray-400"
                    >
                      <path
                        d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                        clipRule="evenodd"
                        fillRule="evenodd"
                      />
                    </svg>
                  </button>

                  {/* Dropdown */}
                  {openDropUser && (
                    <div className="absolute right-0 mt-2 w-40 bg-white rounded-md shadow-lg">
                      <ul className="py-2 text-gray-700">
                        <li>
                          <p className="block px-4 py-2 hover:bg-gray-100">
                            {userName}
                          </p>
                        </li>
                        <li>
                          <p
                            href="#"
                            className="block px-4 py-2 hover:bg-gray-100"
                            onClick={() => setShowModalTicket(true)}
                          >
                            Create Ticket
                          </p>
                        </li>
                        <li>
                          <p
                            href="#"
                            className="block px-4 py-2 hover:bg-gray-100"
                            onClick={logout_action}
                          >
                            Logout
                          </p>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </nav>

            {/* DIV Sidebar Menu: Contiene logo y botones de select*/}
            <div
              className={`bg-gray-100  z-50 transition-all duration-100 ease-in-out flex-shrink-0 flex flex-col
            ${isOpenSidebar ? "w-72" : "w-0 overflow-hidden border-4"}`}
            >
              {isOpenSidebar && (
                <div className=" text-xl font-medium text-black flex flex-col items-center bg-gray-200 border-4 ">
                  <img
                    className="h-18 w-auto hover:bg-gray-200 rounded-md cursor-pointer"
                    src={model_mining_logo_3}
                    alt="Model Mining"
                    onClick={toggleSidebar}
                  />
                </div>
              )}
              <div className="flex-1 overflow-y-auto p-2 bg-gray-100 border-4 ">
                <ul className="p-4 space-y-1 bg-gray-100">
                  {allMainMenu.map((menu) => (
                    <li>
                      <button
                        className="block p-2 rounded hover:bg-gray-400 w-full text-left"
                        onClick={() => toggleSubmenu(menu.id_menu)}
                      >
                        {menu.name}
                      </button>
                      {menu.is_show && (
                        <ul className="ml-4 mt-1 space-y-1 text-sm text-gray-700">
                          {allSubMenu.map(
                            (subMenu) =>
                              menu.id_menu == subMenu.id_menu && (
                                <li>
                                  <button
                                    className="block p-2 rounded hover:bg-gray-300 w-full text-left"
                                    onClick={() =>
                                      openModulesMenu(subMenu.id_sub_menu)
                                    }
                                  >
                                    {subMenu.name}
                                  </button>
                                </li>
                              )
                          )}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Contenedor Principal: En el se montan los modales, mapas, equipos, etc */}
            <div className=" bg-white transiion-all duration-300 ease-in-out h-full  w-full">
              <div className=" w-full h-full p-2">
                {isTransitioning && <IframeBlockerOverlay />}
                    {isRefreshGpsFrame && aplicationInfo && (
                      <MainMapContainer
                        showGeofenceInfo={geofenceShow}
                        showEquipmentInfo={equipmentModuleShow}
                        applicationInfo={aplicationInfo}
                        isFooterOpen={isContainerModalsOpen}
                        isOpenSidebar={isOpenSidebar}
                      />
                    )}
                    {allSubMenu.map(
                      (subMenu) =>
                        subMenu.is_show && (
                          <Modal_Frame
                            key={subMenu.id_sub_menu}
                            id={subMenu.id_sub_menu}
                            onFocusModal={focusModals}
                            isOpen={subMenu.is_show}
                            onClose={closeModulesMenu}
                            title={subMenu.name}
                            size="2xl"
                            zIndex={subMenu.zindex}
                            isMinimize={subMenu.is_minimize}
                            minimizeFunction={minimizeModulesMenu}
                            url_frame={subMenu.url_frame}
                            sidebar_info={{ active: isOpenSidebar, width: 72 }}
                            SelectedAppID={selectedApp.value}
                            selectedUserId={userId}
                            isComponent={subMenu.is_component}
                            componentName={
                              componentsSystem[subMenu.component_name] ?? null
                            }
                          />
                        )
                    )}
                    {showModalTicket && (
                      <ModalGenerateTickets
                        setShowModal={setShowModalTicket}
                        userName={userName}
                        applicationInfo={aplicationInfo.application_name}
                      />
                    )}
               
              </div>
            </div>


             {/* Footer Bar: En el se van cargando los subMenuQue se abren.*/}
            {isContainerModalsOpen && (
              <div
                className={`fixed flex bottom-0 left-0 right-0 h-8 px-2 bg-gray-100 items-center justify-start border-2
                   ${isOpenSidebar ? "ml-72" : ""}`}
              >
                {allSubMenu.map(
                  (subMenu) =>
                    subMenu.is_show && (
                      <div>
                        <button
                          className="text-white border-solid ml-1 px-1 bg-gray-700"
                          onClick={() =>
                            focusModals(subMenu.id_sub_menu)
                          }
                        >
                          {subMenu.name}
                        </button>
                      </div>
                    )
                )}
              </div>
            )}
          </div>
        )}
    </div>
  );
};
